<script>
import SetCounter from '@components/counters/set-counter.vue';
import SetDetailsCircuitAddExerciseBtn from '@components/circuit/set-details-circuit-add-exercise-btn.vue';
import SetDetailsCircuitExercisePhoto from '@components/circuit/set-details-circuit-exercise-photo.vue';
import SetDetailsCircuitExerciseRemoveBtn from '@components/circuit/set-details-circuit-exercise-remove-btn.vue';
import SetDetailsCircuitExerciseReorderBtns from '@components/circuit/set-details-circuit-exercise-reorder-btns.vue';
import SetDetailsCircuitExerciseSetHeader from '@components/circuit/set-details-circuit-exercise-set-header.vue';
import SetDetailsCircuitExerciseSetTitle from '@components/circuit/set-details-circuit-exercise-set-title.vue';
import SetDetailsCircuitExerciseTitle from '@components/circuit/set-details-circuit-exercise-title.vue';
import SetRow from '@components/exercise/set-row.vue';

export default {
  components: {
    SetCounter,
    SetDetailsCircuitAddExerciseBtn,
    SetDetailsCircuitExercisePhoto,
    SetDetailsCircuitExerciseRemoveBtn,
    SetDetailsCircuitExerciseReorderBtns,
    SetDetailsCircuitExerciseSetHeader,
    SetDetailsCircuitExerciseSetTitle,
    SetDetailsCircuitExerciseTitle,
    SetRow,
  },
  props: {
    exercise: {
      type: Object,
      required: true,
      default: () => {},
    },
    coverPhoto: {
      type: String,
      required: true,
      default: '',
    },
    label: {
      type: String,
      required: true,
      default: '',
    },
    count: {
      type: Number,
      required: true,
      default: 0,
    },
    isLastExercise: {
      type: Boolean,
      required: false,
    },
    isSingleExerciseCircuit: {
      type: Boolean,
      required: false,
    },
    allowEditing: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    updateSets(type) {
      this.$emit('update-sets', type);
    },
    adjustReps(count) {
      this.$emit('adjust-reps', count);
    },
    adjustTime(count) {
      this.$emit('adjust-time', count);
    },
    adjustWeight(count) {
      this.$emit('adjust-weight', count);
    },
    adjustRest(count) {
      this.$emit('adjust-rest', count);
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col col-md-4 no-pad-right">
        <div class="row no-pad-horizontal">
          <div class="col-lg-6 col-xl-4 exercise-actions">
            <div class="row">
              <SetDetailsCircuitExercisePhoto
                :photo="coverPhoto"
                @view-photo="$emit('view-photo', coverPhoto)"
              />
            </div>
            <div class="actions-wrapper">
              <SetDetailsCircuitExerciseRemoveBtn
                v-if="allowEditing"
                @remove-exercise="$emit('remove-exercise')"
              />

              <div
                v-if="!isSingleExerciseCircuit && allowEditing"
                class="row reorder"
              >
                <div class="col">
                  <span class="col title">Reorder Exercise</span>
                  <div class="row justify-content-center">
                    <SetDetailsCircuitExerciseReorderBtns
                      @move-up="$emit('move-up')"
                      @move-down="$emit('move-down')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <SetDetailsCircuitExerciseTitle :label="exercise.label" />

            <div class="row pl-0">
              <div class="col-5">
                <SetDetailsCircuitExerciseSetTitle />

                <div class="row">
                  <div class="col">
                    <SetCounter
                      :allowEditing="allowEditing"
                      :count="exercise.setDirections.length"
                      @update-sets="updateSets"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="isLastExercise">
          <SetDetailsCircuitAddExerciseBtn
            v-if="allowEditing"
            @show-exercise-list="$emit('show-exercise-list')"
          />
        </div>
      </div>
      <div class="col-8 no-pad-horizontal">
        <div class="row no-pad-horizontal">
          <div class="col">
            <SetDetailsCircuitExerciseSetHeader />
            <SetRow
              v-for="(setDirections, i) in exercise.setDirections"
              :key="i"
              :setDirections="setDirections"
              :exerciseSetIndex="i"
              @adjust-reps="adjustReps"
              @adjust-time="adjustTime"
              @adjust-weight="adjustWeight"
              @adjust-rest="adjustRest"
              :allowEditing="allowEditing"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable no-descending-specificity
// stylelint-disable selector-pseudo-element-no-unknown

.row {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.exercise-actions {
  margin-right: 3rem;
  position: relative;

  .row {
    padding-left: unset;
    padding-right: unset;
  }

  .reorder {
    margin-bottom: 3rem;
    margin-left: unset;
    margin-right: unset;
    margin-top: 1rem;
    position: relative;
    width: 100%;

    .col {
      padding-left: unset;
      padding-right: unset;
      text-align: center;
    }

    .title {
      color: $color-medium-gray-alt;
      font-size: 11px;
      font-style: normal;
      font-weight: 800;
      letter-spacing: 0.09px;
      line-height: 18px;
      padding-left: unset;
      padding-right: unset;
      white-space: nowrap;
    }

    .right-arrow {
      align-items: center;
      background: rgba($color-black-one-wo-rgb, 0.1);
      border-radius: 4px;
      display: flex;
      height: 4rem;
      justify-content: center;
      margin-left: 2px;

      path {
        stroke: $color-action;
      }

      &:hover {
        background: rgba($color-black-one-wo-rgb, 0.2);
        cursor: pointer;
      }
    }

    .left-arrow {
      align-items: center;
      background: rgba($color-black-one-wo-rgb, 0.05);
      border-radius: 4px;
      display: flex;
      height: 4rem;
      justify-content: center;
      margin-right: 2px;

      path {
        stroke: $color-action;
      }

      &:hover {
        background: rgba($color-black-one-wo-rgb, 0.15);
        cursor: pointer;
      }
    }
  }

  .action-remove {
    align-items: center;
    background: rgba($color-black-one-wo-rgb, 0.05);
    border-radius: 4px;
    display: flex;
    height: fit-content;
    justify-content: center;
    margin-top: 15px;
    padding: 1rem;
    white-space: nowrap;

    .wrapper {
      color: $color-red;
      font-size: 1.2rem;
      font-weight: 600;
      letter-spacing: 0.116667px;
      line-height: 1.9rem;

      @include media('xxxl', null) {
        font-size: 1.4rem;
      }

      &:hover {
        cursor: pointer;
      }

      .icon-trash {
        margin-right: 0.7rem;

        path {
          fill: $color-red;
        }
      }
    }

    &:hover {
      background: rgba($color-black-one-wo-rgb, 0.15);
      cursor: pointer;
    }
  }
}

::v-deep .exercise-set-detail-counters {
  .set-counter .set-num,
  .rep-counter.minimal .rep-num,
  .time-counter .time-num,
  .weight-counter .weight-num,
  .rest-counter .rest-num {
    font-size: 2rem;
  }
}
</style>
